import { render } from "./SchoolGardensSlider.vue?vue&type=template&id=4619cee4"
import script from "./SchoolGardensSlider.vue?vue&type=script&lang=js"
export * from "./SchoolGardensSlider.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SchoolGardensSlider.vue?vue&type=style&index=0&id=4619cee4&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__